import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { Constants } from 'src/app/constants/constants';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private activeRequests = 0; // Counter to track active requests

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the Skip_Loader header is present and its value    
    const skipLoader = req.headers.has(Constants.SKIP_LOADER_HEADER_KEY) && req.headers.get(Constants.SKIP_LOADER_HEADER_KEY) === 'true';
    if (!skipLoader) {
      // Increment the active requests counter
      this.activeRequests++;

      // Show the loader if it's the first request
      if (this.activeRequests === 1) {
        this.loaderService.showLoader();        
      }
    }
    //console.log(`${this.activeRequests} - Loader started for URL: ${req.url} - skipLoader = ${skipLoader}`);
    return next.handle(req).pipe(
      finalize(() => {
        // Decrement the active requests counter
        if(!skipLoader) {
          this.activeRequests--;
        }
        if(this.activeRequests < 0) {
          this.activeRequests = 0; // Reset to zero if it goes negative
        }

        // Hide the loader only if there are no active requests
        if (this.activeRequests === 0) {
          this.loaderService.hideLoader();          
        }
        
        //console.log(`${this.activeRequests} - Loader stopped for URL: ${req.url} - skipLoader = ${skipLoader}`);
      })
    );
  }
}
